export function updateMenuButton() {
  const $currentToggle = $(`.mobile-nav-toggle`);
  const $closeToggle = $('.mobile-menu-container .close-mobile-menu');
  const toggleAttributes = { tabindex: '0', role: 'button', 'aria-label': 'Toggle mobile menu' };

  createMenuButtons();
  bindOpenToggleKeyboard();

  function createMenuButtons() {
    $currentToggle.attr(toggleAttributes).append(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/>
    </svg>
    `);

    $closeToggle.attr(toggleAttributes).append(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
      <path d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z"/>
    </svg>
    `);
  }

  function bindOpenToggleKeyboard() {
    $currentToggle.on('keydown click', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        event.preventDefault();
        $(this).trigger('click');
        return;
      } else if (event.type === 'click') {
        bindCloseToggleKeyboard();
      } else {
        return;
      }
      appendNavFooterItems();
    });
  }

  function bindCloseToggleKeyboard() {
    $closeToggle.attr(toggleAttributes).focus();
    $closeToggle.on('keydown click', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        event.preventDefault();
        $(this).trigger('click');
        removeNavFooterItems();
        return;
      }
      if (event.type === 'click') {
        removeNavFooterItems();
      }
      $currentToggle.get(0)?.focus();
    });
  }

  function appendNavFooterItems() {
    const $navFooter = $('.mobile-menu-container .mobile-menu-footer-links');
    const $footerItems = $('#headerTopItems');

    $footerItems
      .find('a')
      .get()
      .reverse()
      .forEach(function (item) {
        const $footerItem = $(item);

        $navFooter.prepend(
          `<a class="dynamicFooterItems" href="${$footerItem.attr('href')}">${$footerItem.text()}</a>`,
        );
      });
  }

  function removeNavFooterItems() {
    const $navFooter = $('.mobile-menu-container .mobile-menu-footer-links .dynamicFooterItems');
    $navFooter.remove();
  }
}

export function setNavItemAttributes() {
  $('#mainNavigation .groups .group').each(function () {
    const $group = $(this);

    if ($group.attr('aria-haspopup') === 'true') {
      $group.children('a.showingNav').attr('tabindex', '0');
    }

    if (
      $group.attr('aria-haspopup') === 'false' &&
      $group.children('a.showingNav').attr('href') == undefined
    ) {
      $group.children('a.showingNav').parent().addClass('no-link');
    }
  });
}
